/* eslint-disable graphql/template-strings */
import { gql, QueryHookOptions, useQuery } from '@apollo/client';
import type {
  GetCommentsByEntityNamePaginatedResponse,
  GetCommentsByEntityNamePaginatedVariables,
} from './types';

export const GET_COMMENTS_BY_ENTITY_NAME_PAGINATED = gql`
  query getCommentsByEntityNamePaginated(
    $entity_name: String!
    $tenant: String!
    $offset: Int
    $size: Int
    $sort: CommentSortParameterInput
    $start_ts: Float!
    $end_ts: Float!
  ) {
    getCommentsByEntityNamePaginated(
      entity_name: $entity_name
      tenant: $tenant
      offset: $offset
      size: $size
      sort: $sort
      start_ts: $start_ts
      end_ts: $end_ts
    ) {
      total_count
      offset
      size
      comments {
        comment_id
        comment
        created_at
        author_alias
        severity
        alert_name
        parent {
          parent_object_id
          parent_object_type
        }
      }
    }
  }
`;

export const useGetCommentsByEntityNamePaginated = (
  options: QueryHookOptions<
    GetCommentsByEntityNamePaginatedResponse,
    GetCommentsByEntityNamePaginatedVariables
  >,
) => {
  return useQuery<
    GetCommentsByEntityNamePaginatedResponse,
    GetCommentsByEntityNamePaginatedVariables
  >(GET_COMMENTS_BY_ENTITY_NAME_PAGINATED, options);
};
